export default __webpack_public_path__ + "testimonial-landlord-71195b7aca97c2c027a3d1bfef51f438.bundle.jpg";